import React from 'react';
import cn from 'classnames';
import { Form, Localization } from 'connex-cds';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { useTicketContext } from '../../../../TicketContext';
import { FLOW } from '../Acceptance';
import style from './style';

const Styled = styled.div`
  ${style}
`;

export const HeaderDesktop = ({
  flow,
  submitAcceptanceVisible,
  entitySupportedLanguages = [],
  errors,
  earlyAcceptance,
}) => {
  const {
    Components: { SubmitButton },
  } = Form.useFormContext();

  const { submitted, ticket } = useTicketContext();

  return (
    <Styled className={cn(['header-desktop'], { 'early-acceptance': earlyAcceptance })}>
      <div className={cn('left-side')}></div>
      <div className={cn('right-side')}>
        <Localization.LocaleSwitcher persist={false} entitySupportedLanguages={entitySupportedLanguages} />
        {flow === FLOW.ACCEPT_REJECT || (flow === FLOW.SIGNATURE_NO_SIGNATURE && submitAcceptanceVisible) ? (
          <SubmitButton
            stringId={
              ticket?.customerStatus?.statusCode === 'REJECTED'
                ? 'rejected'
                : submitted
                ? 'accepted'
                : 'submitAcceptance'
            }
            data-testid="submit-acceptance-button"
            disabledWhenNotDirty={false}
            disabled={submitted || !isEmpty(errors)}
          />
        ) : null}
      </div>
    </Styled>
  );
};
